// Corresponds to EditorThemeClasses type in lexical/LexicalEditor.js:
export const LexicalTheme = {
    blockCursor: 'PlaygroundEditorTheme__blockCursor',
    code: 'PlaygroundEditorTheme__code',
    codeHighlight: {
        atrule: 'PlaygroundEditorTheme__tokenAttr',
        attr: 'PlaygroundEditorTheme__tokenAttr',
        boolean: 'PlaygroundEditorTheme__tokenProperty',
        builtin: 'PlaygroundEditorTheme__tokenSelector',
        cdata: 'PlaygroundEditorTheme__tokenComment',
        char: 'PlaygroundEditorTheme__tokenSelector',
        class: 'PlaygroundEditorTheme__tokenFunction',
        'class-name': 'PlaygroundEditorTheme__tokenFunction',
        comment: 'PlaygroundEditorTheme__tokenComment',
        constant: 'PlaygroundEditorTheme__tokenProperty',
        deleted: 'PlaygroundEditorTheme__tokenProperty',
        doctype: 'PlaygroundEditorTheme__tokenComment',
        entity: 'PlaygroundEditorTheme__tokenOperator',
        function: 'PlaygroundEditorTheme__tokenFunction',
        important: 'PlaygroundEditorTheme__tokenVariable',
        inserted: 'PlaygroundEditorTheme__tokenSelector',
        keyword: 'PlaygroundEditorTheme__tokenAttr',
        namespace: 'PlaygroundEditorTheme__tokenVariable',
        number: 'PlaygroundEditorTheme__tokenProperty',
        operator: 'PlaygroundEditorTheme__tokenOperator',
        prolog: 'PlaygroundEditorTheme__tokenComment',
        property: 'PlaygroundEditorTheme__tokenProperty',
        punctuation: 'PlaygroundEditorTheme__tokenPunctuation',
        regex: 'PlaygroundEditorTheme__tokenVariable',
        selector: 'PlaygroundEditorTheme__tokenSelector',
        string: 'PlaygroundEditorTheme__tokenSelector',
        symbol: 'PlaygroundEditorTheme__tokenProperty',
        tag: 'PlaygroundEditorTheme__tokenProperty',
        url: 'PlaygroundEditorTheme__tokenOperator',
        variable: 'PlaygroundEditorTheme__tokenVariable',
    },
    heading: {
        h1: 'is-size-1',
        h2: 'is-size-2',
        h3: 'is-size-3',
        h4: 'is-size-4',
        h5: 'is-size-5',
        h6: 'is-size-6',
    },
    indent: 'indent',
    list: {
        ol: 'ol',
        ul: 'ul',
        checklist: 'PlaygroundEditorTheme__checklist',
        listitem: 'li',
        listitemChecked: 'PlaygroundEditorTheme__listItemChecked',
        listitemUnchecked: 'PlaygroundEditorTheme__listItemUnchecked',
    },
    paragraph: 'paragraph',
    text: {
        bold: 'is-bold',
        code: 'is-code',
        italic: 'is-italic',
        highlight: 'is-highlight',
        strikethrough: 'is-strike-through',
        subscript: 'is-subscript',
        superscript: 'is-superscript',
        underline: 'is-underline',
        underlineStrikethrough: 'is-underline-strike-through',
    },
};
//# sourceMappingURL=LexicalTheme.js.map